module.exports = __webpack_public_path__ + "static/media/blogcake.c60bb6eb.jpg";